module.exports = __webpack_public_path__ + "img/astra-plus.e2e500e5.jpg";